module.exports = __webpack_public_path__ + "static/media/r4s3.31a06abd.jpg";